"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.useAppLoginStore = void 0;
const pinia_1 = require("pinia");
const AuthenticatedUser_1 = __importDefault(require("./AuthenticatedUser"));
const fetch_1 = __importDefault(require("../../common/utils/fetch"));
const i18n_1 = __importDefault(require("../../common/i18n"));
exports.useAppLoginStore = (0, pinia_1.defineStore)("appLoginStore", {
    state: () => ({
        authenticatedUser: AuthenticatedUser_1.default.factory(),
        authCheck: false,
        pendingAppUser: null,
        authCheckLoading: false,
        authChecked: false,
        tokenLoading: false,
        payload: [],
    }),
    getters: {
        authenticated: (state) => {
            if (state.authenticatedUser === null) {
                return false;
            }
            return state.authChecked && !state.authCheck;
        },
    },
    actions: {
        checkAuth(router) {
            this.authCheck = false;
            this.authCheckLoading = true;
            this.authChecked = false;
            return new Promise((resolve, reject) => {
                (0, fetch_1.default)(router.resolve({ name: "security_check_auth" }).href)
                    .then((response) => {
                    this.payload = response.payload;
                    this.authCheckLoading = false;
                    this.authCheck = false;
                    this.authChecked = true;
                    resolve();
                })
                    .catch((error) => {
                    this.authCheckLoading = false;
                    this.authCheck = false;
                    this.authChecked = true;
                    reject(error);
                });
            });
        },
        //kliens oldali
        setNewAppUser(email, router) {
            return new Promise((resolve, reject) => {
                (0, fetch_1.default)(router.resolve({ name: "app_gen_auth_code" }).href, {
                    method: "POST",
                    body: JSON.stringify({ email: email }),
                })
                    .then((loginResponse) => {
                    if (typeof loginResponse.error !== "undefined") {
                        // login failed
                        reject(i18n_1.default.trans("autcode_gen_failed", "Autentication code generation failed!", "security"));
                        return;
                    }
                    sessionStorage.setItem("pendingAppUser", email);
                    this.pendingAppUser = email;
                    router.push({ name: "frontend_verification" });
                    //do something on success
                    //átírányítás a verifikációs oldalra ha nincs hiba
                    //router.push({ name: "frontend_verification" });
                })
                    .catch((err) => {
                    reject(err);
                });
            });
        },
        //kliens oldali bejelentkezés
        appLogin(authCode, router) {
            if (!this.pendingAppUser) {
                this.pendingAppUser = sessionStorage.getItem("pendingAppUser");
            }
            if (!this.pendingAppUser) {
                throw Error(i18n_1.default.trans("app_login_no_email", "Something Wrong happened", "security"));
            }
            return new Promise((resolve, reject) => {
                (0, fetch_1.default)(router.resolve({ name: "app_login" }).href, {
                    method: "POST",
                    body: JSON.stringify({
                        email: this.pendingAppUser,
                        authCode: authCode,
                    }),
                })
                    .then((loginResponse) => {
                    if (typeof loginResponse.error !== "undefined") {
                        // login failed
                        reject(i18n_1.default.trans("app_login_failed", "Login failed. Please, check your authentication code in your email inbox!", "security"));
                        return;
                    }
                    // backendről visszakapott jwtToken beállítása
                    this.authenticatedUser = AuthenticatedUser_1.default.factory(loginResponse.token);
                    sessionStorage.removeItem("pendingAppUser");
                    sessionStorage.setItem("appToken", loginResponse.token);
                    this.pendingAppUser = null;
                    resolve(this.checkAuth(router));
                    router.push({ name: "frontend_reservation" });
                })
                    .catch((err) => {
                    reject(err);
                });
            });
        },
        async initApplogin(router) {
            const token = sessionStorage.getItem("appToken");
            if (token) {
                this.authenticatedUser = AuthenticatedUser_1.default.factory(token);
                //console.log(this.authenticatedUser);
                try {
                    await this.checkAuth(router);
                }
                catch (err) {
                    console.error(err);
                    // kezeld a hibát, pl. továbbítsd a felhasználót a bejelentkezési oldalra
                }
            }
        },
    },
});
